import { computed } from 'vue'
import { EVENTS } from '../constants/dropdown-button-constants.js'

/**
 * Event handling for DropDown Button component
 * Giữ nguyên logic gốc - không thay đổi behavior
 */
export function useDropDownButtonEvents(props, emit) {
  
  // Menu item click handler - giữ nguyên logic từ file gốc
  const clickItem = (item) => {
    emit(EVENTS.MENU_CLICK, item)
  }
  
  // Event handlers object
  const eventHandlers = computed(() => ({
    clickItem
  }))
  
  return {
    clickItem,
    eventHandlers
  }
}
